import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { useState } from 'react'
import Home from './app/home'
import About from './app/about'
import Projects from './app/projects'
import Contact from './app/contact'
import NavBar from './components/NavBar'
import Lanyard from './components/Lanyard'
import ProjectsPage from './app/projects-all'



export default function App() {
  return(
    <BrowserRouter>
      <NavBar />
      <main className="relative z-10">
        <Routes>
          <Route path={'/'} element={<Home />} />
          <Route path={'/home'} element={<Home />} />
          <Route path={'/about'} element={<About />} />
          <Route path={'/projects'} element={<Projects />} />
  {/* LIST PAGE */}
  <Route path="/projects-all" element={<ProjectsPage />} />


          <Route path={'/contact'} element={<Contact />} />
        </Routes>
      </main>
    </BrowserRouter>
  )
}

